import { createLocalTranscriptStore } from "../localTranscriptStore";

/**
 * Kaltura transcript buffer. Kaltura's SDK has no ears and no brain — *we*
 * generate both sides of the conversation — so there is nothing to fetch back
 * at end of session: the conversation loop appends turns here as they happen
 * and the session adapter reads them out.
 */
const store = createLocalTranscriptStore();

export const startTranscript = store.startTranscript;
export const appendTranscriptTurn = store.appendTranscriptTurn;
export const readTranscript = store.readTranscript;
export const clearTranscript = store.clearTranscript;
